// extracted by mini-css-extract-plugin
module.exports = {"iframe":"LinkPreview_iframe__y5QdE","container":"LinkPreview_container__ROkKp","loading":"LinkPreview_loading__S9IkT"};